import PropTypes from 'prop-types';
import { useEffect } from 'react';

import SocialMediaLoginButtonsGroup from 'components/SocialMediaLoginButtonsGroup';

import { sendEvent } from 'lib/gtag';
import placeholder from 'lib/placeholder';

import Heading from '../Heading';

const SocialMediaLogin = ({
  gaEventCategory,
  greetingsMessage = placeholder('titles.socialSignin'),
  onSuccess,
}) => {
  useEffect(() => {
    sendEvent({
      action: 'initial_modal_appear',
      category: gaEventCategory,
    });
  }, []);

  return (
    <div className="flex flex-col items-center">
      <Heading>{greetingsMessage} 💰</Heading>
      <SocialMediaLoginButtonsGroup
        appleLoginButtonProps={{ onSuccess }}
        facebookLoginButtonProps={{ onSuccess }}
        gaEventCategory={gaEventCategory}
        googleLoginButtonProps={{ onSuccess }}
      />
    </div>
  );
};

SocialMediaLogin.propTypes = {
  gaEventCategory: PropTypes.string.isRequired,
  greetingsMessage: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
};

export default SocialMediaLogin;
